<template>
  <Page class="page-container--scrollable-table">
    <PageContent>
      <TypeTabsAndSelection />
      <RouterView />
    </PageContent>
  </Page>
</template>

<script lang="ts" setup>
import { RouteName } from '@/types/router'
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import { useTypesContext } from '@/composables/deepbox/use-types-context.ts'
import { useBreadcrumbRegistry } from '@/composables/use-breadcrumb-registry.ts'
import TypeTabsAndSelection from '@/components/deepbox/type/TypeTabsAndSelection.vue'
import Page from '@/components/page/Page.vue'
import PageContent from '@/components/page/PageContent.vue'

definePage({
  meta: {
    breadcrumbLabelKey: '',
  },
})

const { overrideBreadcrumb } = useBreadcrumbRegistry()
const { permissions } = useAuthorizationContext()
const { selectedType } = useTypesContext()

watch(
  selectedType,
  (newValue) => {
    if (!newValue) return

    overrideBreadcrumb(
      '/organizations/[organizationId]/deepbox/types/[typeId]' as RouteName,
      newValue.name,
    )
  },
  { immediate: true },
)

usePageAccess(computed(() => !permissions.canViewBoxes))
</script>
